<template>
	<div>
		<ui-clipboard-input
			v-model="link"
			:disabled="isFetching || link.length === 0"
			hint="Link copied to clipboard"
			label="Live media link"
		/>
		<ui-dialog-footer>
			<ui-button
				:disabled="isFetching || (lifetime <= 0 && expires === 0)"
				primary
				text="Generate link"
				tooltip="Click here to generate a new link"
				@click="fetchShareMediaLink"
			/>
		</ui-dialog-footer>
	</div>
</template>

<script>
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";
import UiButton from "lib/components/ui/Button";
import UiClipboardInput from "lib/components/ui/ClipboardInput";
import UiDialogFooter from "lib/components/ui/DialogFooter";

export default {
	name: "MediaShareLink",
	components: {
		UiButton,
		UiClipboardInput,
		UiDialogFooter
	},
	props: {
		downloadable: {
			type: Boolean,
			default: false,
			required: false
		},
		expires: {
			type: Number,
			required: true
		},
		lifetime: {
			type: Number,
			required: true
		},
		mediaId: {
			type: String,
			required: true
		},
		password: {
			type: String,
			default: "",
			required: false
		}
	},
	data() {
		return {
			isFetching: false,
			link: ""
		};
	},
	computed: {
		downloadParameter() {
			return this.downloadable ? "&d=1" : "";
		}
	},
	methods: {
		fetchShareMediaLink() {
			const parameters = {
				key: this.password
			};

			if (this.expires !== 0)
				parameters.expires = this.expires;

			if (this.lifetime > 0)
				parameters.lifetime = this.lifetime;

			this.isFetching = true;

			http.post(`/api/v2/media/${this.mediaId}/share`, parameters)
			.then((response) => {
				this.link = `${location.origin}/play?id=${encodeURIComponent(response.data.secid)}${this.downloadParameter}`;
			})
			.catch((error) => {
				alert.error("Unable to generate link", error.response);
			})
			.finally(() => {
				this.isFetching = false;
			});
		}
	}
};
</script>
